// Bandjes-referentie — PM26.
// Bron: officieel "Accreditatieschema Pal Mundo Festival 2026" (poster, ontvangen 18-07
// via organisatie, gefotografeerd). Kleuren benaderd op de poster-afbeelding.
// JA/NEE-toegang verschilt per positie — het ingevulde schema hangt bij de post;
// bij twijfel: CP → CSS.

interface Band {
  naam: string;
  kleurNaam: string;
  kleur: string;
  tekst: string;
  regel?: string;
}

const BANDJES: Band[] = [
  {
    naam: "ALL AUTHORITY",
    kleurNaam: "magenta (+ pas)",
    kleur: "#c2185b",
    tekst: "#ffffff",
    regel:
      "Alleen geldig i.c.m. pas · te allen tijde overal toegang · mag uitzondering maken op de regels — géén discussies · mag escorteren",
  },
  { naam: "ALL AREA", kleurNaam: "bordeaux", kleur: "#7f1d1d", tekst: "#ffffff" },
  { naam: "CREW", kleurNaam: "blauw", kleur: "#2563eb", tekst: "#ffffff" },
  { naam: "ARTIST", kleurNaam: "geel", kleur: "#eab308", tekst: "#1c1917" },
  { naam: "ARTIST MAIN", kleurNaam: "groen", kleur: "#16a34a", tekst: "#ffffff" },
  { naam: "GOLDEN CIRCLE", kleurNaam: "zwart (patroon)", kleur: "#1c1917", tekst: "#ffffff" },
  { naam: "VIP", kleurNaam: "oranje (patroon)", kleur: "#ea580c", tekst: "#ffffff" },
  { naam: "RELATION", kleurNaam: "lila", kleur: "#c4b5fd", tekst: "#1c1917" },
  { naam: "BLESSED by Jonna Fraser", kleurNaam: "goudbruin", kleur: "#a16207", tekst: "#ffffff" },
];

export function Bandjes() {
  if (BANDJES.length === 0) {
    return (
      <div
        className="rounded-2xl px-4 py-3"
        style={{
          background: "rgba(255,180,80,0.05)",
          border: "1px solid rgba(255,180,80,0.18)",
        }}
      >
        <div className="text-2xs tracking-eyebrow uppercase text-zinc-400 mb-1.5">
          Nog niet ontvangen
        </div>
        <p className="text-sm text-zinc-400 leading-relaxed">
          De bandjes-referentie voor Pal Mundo is nog niet aangeleverd. Vraag de
          poster met geldige polsbandjes op bij CSS (Kevin) vóór de deuren
          opengaan. Tot die tijd: beoordeel géén bandjes op basis van deze app —
          bij twijfel altijd CP → CSS.
        </p>
      </div>
    );
  }
  return (
    <div className="card p-3 space-y-2">
      <ul className="space-y-1.5">
        {BANDJES.map((b) => (
          <li key={b.naam}>
            <div
              className="rounded-md px-3 py-2 flex items-baseline justify-between gap-2"
              style={{ backgroundColor: b.kleur, color: b.tekst }}
            >
              <span className="text-sm font-semibold tracking-wide">
                {b.naam}
              </span>
              <span className="text-2xs opacity-80">{b.kleurNaam}</span>
            </div>
            {b.regel && (
              <p className="text-2xs text-zinc-400 px-1 pt-1">{b.regel}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
